export default {
  shopNow: "立即購買",
  comingSoon: "敬請期待",
  megaOffer: "超值優惠",
  home: { title: "hoem title 000" },
  colorSelected: "已選擇顏色：",
  discountBar: {
    1: { discount: "49折", title: "咖啡愛好者專享!" },
    2: { discount: "55折", title: "牛奶愛好者專享" },
    3: { discount: "70折", title: "精選配件優惠" },
  },
  common: {
    scroll: "向下捲動<br/>查看更多",
    buyNow: "BUY<br/>NOW",
    learnMore: "條款及細則",
    offer: "立即購買",
    ingredient: "材料",
    step: "STEP",
    bestSeller: "BEST SELLER",
    addToCart: "加入購物車",
    viewAll: "查看全部",
    close: "關閉",
    minutes: "分鐘",
    servings: "份量",
    prepTime: "準備時間",
    ingredients: "材料",
    instructions: "製作步驟",
    tips: "小貼士",
    people: "人",
  },

  toteBag: {
    title: "ASH 限量版手提袋",
    description:
      "Nespresso 與意大利時尚鞋履品牌 ASH 合作推出限量環保 ASH Tote Bag。",
  },
  giftCups: {
    title: "Barista 調酒師咖啡杯 小杯 (300毫升)",
    description:
      "用 Barista 調酒師專用酒杯，以飽滿的熱情結束美好的一天。<br>夜幕降臨，Federico Peri 設計的 Barista 調酒師專用酒杯將為您帶來這一刻。酒杯採用透明玻璃，方便您凝視冰鎮咖啡，杯身的垂直條紋在酒杯周圍舞動，讓您在線條之間或線條之外盡情探索。",
  },
  miniCaps: {
    title: "Singles' Day 5筒咖啡粉囊套裝",
    description: `<ul class="disc">
      <li>佳節系列Espresso咖啡 X 10</li>
      <li>佳節系列Cinnamon And Candied Tamarind咖啡 X 10</li>
      <li>佳節系列Sweet Almond And Hibiscus咖啡 X 10</li>
      <li>Nocciola咖啡 x 10</li>
      <li>Caramello咖啡 x 10</li>
    </ul>`,
  },
  vlCaps: {
    title: "Singles' Day 3筒咖啡粉囊套裝",
    description: `<ul class="disc">
      <li>佳節系列Espresso咖啡 X 10</li>
      <li>佳節系列Cinnamon And Candied Tamarind咖啡 X 10</li>
      <li>佳節系列Sweet Almond And Hibiscus咖啡 X 10</li>
    </ul>`,
  },
  counter: {
    title: {
      brand: "NESPRESSO",
      event: "11.11 SINGLES' DAY",
      date: "2025年11月5 至 12 日",
    },
    days: "天",
    hours: "小時",
    minutes: "分鐘",
    seconds: "秒",
  },

  landingBanner: {
    vertuoPopOffer: "Vertuo pop<br /> 優惠",
    miniOffer: "Essenza Mini<br /> 優惠",
    back: "< 返回",
    exclusiveBadge: "單日獨家",
    exclusiveBadgeTitle: "雙11",
    exclusiveBadgeSubtitle: "網上限定",
    productTitle: "ESSENZA MINI 咖啡機套裝優惠",
    productTitleV: "Vertuo pop 咖啡機套裝優惠",
    productDescription:
      "完整咖啡體驗，包含咖啡機、配件和優質粉囊，為您帶來完美沖調。",
    productPrice: "HK$888",
    originalPrice: "HK$1,692",
    discount: "51折",
    coffeeCup: "調酒師咖啡杯",
    ashToteBag: "ASH 限量版手提袋",
    coffeeAssortment: "Singles' Day 5<br/>筒咖啡粉囊套裝",
    vlCapsAssortment: "Singles' Day 3<br/>筒咖啡粉囊套裝",
  },

  products: {
    title: "探索我們的系列",
    subtitle: "找到最適合您生活方式的咖啡機",
  },

  productSection: {
    colorSelected: "已選擇顏色:",
    addToCart: "加入購物車",
    off: "折扣",
    title: "咖啡配件優惠, 專為鮮奶咖啡愛好者",
  },

  mega: {
    title: "超值優惠",
    desc: "雙11超值咖啡豪華組合 – 享最優惠價錢！",
    tab_mini: "ESSENZA MINI",
    tab_verto: "Vertuo Pop",
    mini: [
      {
        title: "Essenza Mini 咖啡機超值優惠",
        remarks: "（最優惠價僅限啞黑色版本）",
        specf: [
          "Essenza Mini 咖啡機 - 啞黑色",
          "Singles' Day 5筒咖啡粉囊套裝",
          "環球之旅10筒咖啡粉囊套裝",
          "Lisbon 咖啡",
          "VIEW Versilo 透明咖啡粉囊盛放器",
          "Barista 調酒師咖啡杯 小杯 (300毫升)",
          "ASH 限量版手提袋 (棕色)",
          "節日限量版毛毯",
          "酒師高腳咖啡杯",
          "限量版雙面手提袋",
        ],
        price: "HK$1,776",
        originalPrice: "HK$3,749",
        discount: "47 折",
        colorName: "啞黑色",
        colorCode: "#000000",
        SKU: "162225",
        img: "/assets/images/2025/mega_mini_black.png",
      },
    ],
    verto: [
      {
        title: "Vertuo Pop 咖啡機超值優惠",
        specf: [
          "Vertuo Pop 咖啡機 - 藍色",
          "Singles' Day 3筒咖啡粉囊套裝",
          "Vertuo 匠心之作精選 6 筒粉囊套裝",
          "Display 系列 直立式咖啡粉囊盛放器 - Vertuo",
          "Barista 調酒師咖啡杯 小杯 (300毫升)",
          "ASH 限量版手提袋 (紅色)",
          "節日限量版毛毯",
          "酒師高腳咖啡杯",
          "限量版雙面手提袋",
        ],
        price: "HK$1,748",
        originalPrice: "HK$3,716",
        discount: "47 折",
        colorName: "白色",
        colorCode: "#FFFFFF",
        SKU: "162226",
        img: "/assets/images/2025/mega_vertuo_white.png",
      },
    ],
  },

  banner: {
    top1: "+$1換購",
    top2: "30粒粉囊及咖啡樽",
    title: "<b>Vertuo Pop</b><br/>Coffee Machine",
    desc: "提供六種顏色選擇 ，纖巧設計能輕易融入任何廚房或工作空間，為您的生活增添香濃繽紛色彩",
    price: "HKD 1,088",
    colorSelected: "已選擇顏色:",
    scrollToSee: "向下捲動<br/>查看更多",
    addOn: "+$1 享受30杯咖啡!",
    only: "限量200套",
    machine: {
      essenzaMini: [
        {
          price: "HK$999 ",
          originalPrice: "HK$$1,981 ",
          discount: "51折",
          remarks: "（最優惠價僅限啞黑色版本）",
          sku: "161531",
          desc: "Essenza Mini - 啞黑色",
          colorName: "啞黑色",
          colorCode: "#000000",
          imgPath: "/assets/images/2025/essenza_mini_black.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_black.png",
          specf: [
            "Essenza Mini 咖啡機",
            "Singles' Day 5筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (棕色)",
          ],
        },
        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "55折",
          remarks: "",
          sku: "161564",
          desc: "Essenza Mini - 青檸綠",
          colorName: "青檸綠",
          colorCode: "#CFE500",
          imgPath: "/assets/images/2025/essenza_mini_green.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_green.png",
          specf: [
            "Essenza Mini 咖啡機",
            "Singles' Day 5筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (棕色)",
          ],
        },
        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "55折",
          remarks: "",
          sku: "161565",
          desc: "Essenza Mini - 紅色",
          colorName: "紅色",
          colorCode: "#FF0000",
          imgPath: "/assets/images/2025/essenza_mini_red.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_red.png",
          specf: [
            "Essenza Mini 咖啡機",
            "Singles' Day 5筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (棕色)",
          ],
        },
        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "55折",
          remarks: "",
          sku: "161563",
          desc: "Essenza Mini - 深灰色",
          colorName: "深灰色",
          colorCode: "#757575",
          imgPath: "/assets/images/2025/essenza_mini_grey.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_grey.png",
          specf: [
            "Essenza Mini 咖啡機",
            "Singles' Day 5筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (棕色)",
          ],
        },

        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "55折",
          remarks: "",
          sku: "161562",
          desc: "Essenza Mini - 純白色",
          colorName: "純白色",
          colorCode: "#FFFFFF",
          imgPath: "/assets/images/2025/essenza_mini_white.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_white.png",
          specf: [
            "Essenza Mini 咖啡機",
            "Singles' Day 5筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (棕色)",
          ],
        },

        {
          price: "HK$1,088 ",
          originalPrice: "HK$$1,981 ",
          discount: "55折",
          remarks: "",
          sku: "161561",
          desc: "Essenza Mini - 鋼琴黑",
          colorName: "鋼琴黑",
          colorCode: "#000000",
          imgPath: "/assets/images/2025/essenza_mini_black.png",
          imgGift: "/assets/images/2025/essenza_mini_gift.png",
          imgPathPreview: "/assets/images/2025/mini_selected_mat_black.png",

          specf: [
            "Essenza Mini 咖啡機",
            "Singles' Day 5筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (棕色)",
          ],
        },
      ],
      vertuoPop: [
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "51折",
          remarks: "",
          sku: "161566",
          desc: "Vertuo Pop - 紅色",
          colorName: "紅色",
          colorCode: "#FF0000",
          imgPath: "/assets/images/2025/vertuo_pop_red.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_red.png",
          specf: [
            "Vertuo Pop 咖啡機",
            "Singles' Day 3筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (紅色)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "55折",
          remarks: "",
          sku: "161567",
          desc: "Vertuo Pop - 甘草黑",
          colorName: "甘草黑",
          colorCode: "#595959",
          imgPath: "/assets/images/2025/vertuo_pop_black.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_black.png",
          specf: [
            "Vertuo Pop 咖啡機",
            "Singles' Day 3筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (紅色)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "55折",
          remarks: "",
          sku: "161568",
          desc: "Vertuo Pop - 海洋藍",
          colorName: "海洋藍",
          colorCode: "#73ACF2",
          imgPath: "/assets/images/2025/vertuo_pop_blue.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_blue.png",
          specf: [
            "Vertuo Pop 咖啡機",
            "Singles' Day 3筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (紅色)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "55折",
          remarks: "",
          sku: "161569",
          desc: "Vertuo Pop - 椰子白",
          colorName: "椰子白",
          colorCode: "#FFFFFF",
          imgPath: "/assets/images/2025/vertuo_pop_white.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_white.png",
          specf: [
            "Vertuo Pop 咖啡機",
            "Singles' Day 3筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (紅色)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "55折",
          remarks: "",
          sku: "161570",
          desc: "Vertuo Pop - 芒果黃",
          colorName: "芒果黃",
          colorCode: "#F8AA2D",
          imgPath: "/assets/images/2025/vertuo_pop_yellow.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_yellow.png",
          specf: [
            "Vertuo Pop 咖啡機",
            "Singles' Day 3筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (紅色)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "55折",
          remarks: "",
          sku: "161571",
          desc: "Vertuo Pop - 薄荷綠",
          colorName: "薄荷綠",
          colorCode: "#4CD8C5",
          imgPath: "/assets/images/2025/vertuo_pop_aqua.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_aqua.png",
          specf: [
            "Vertuo Pop 咖啡機",
            "Singles' Day 3筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (紅色)",
          ],
        },
        {
          price: "HK$999",
          originalPrice: "HK$1,976",
          discount: "55折",
          remarks: "",
          sku: "161572",
          desc: "Vertuo Pop - 紫丁香",
          colorName: "紫丁香",
          colorCode: "#D6BBED",
          imgPath: "/assets/images/2025/vertuo_pop_aqua.png",
          imgGift: "/assets/images/2025/vertuo_pop_gift.png",
          imgPathPreview: "/assets/images/2025/vertuo_selected_liac.png",
          specf: [
            "Vertuo Pop 咖啡機",
            "Singles' Day 3筒咖啡粉囊套裝",
            "Barista 調酒師咖啡杯 小杯 (300毫升)",
            "ASH 限量版手提袋 (紅色)",
          ],
        },
      ],
    },
  },

  productSectionData: [
    [
      {
        name: "Aeroccino3 打奶器套裝優惠",
        desc: [
          "Aeroccino3 黑色打奶器",
          "VIEW 咖啡匙（細）一套 6 件",
          "Barista 毛巾, 1套2件",
        ],
        price: "499",
        orgPrice: "1130",
        discount: "45折",
        img: "/assets/images/2025/milk_lover_black.png",
        colorName: "黑色",
        colorCode: "#000000",
        sku: "3594-SG-BK",
      },
      {
        name: "Aeroccino3 打奶器套裝優惠",
        desc: [
          "Aeroccino3 紅色打奶器",
          "VIEW 咖啡匙（細）一套 6 件",
          "Barista 毛巾, 1套2件",
        ],
        price: "499",
        orgPrice: "1130",
        discount: "45折",
        img: "/assets/images/2025/milk_lover_red.png",
        colorName: "紅色",
        colorCode: "#BA3030",
        sku: "3594-SG-RE",
      },
      {
        name: "Aeroccino3 打奶器套裝優惠",
        desc: [
          "Aeroccino3 白色打奶器",
          "VIEW 咖啡匙（細）一套 6 件",
          "Barista 毛巾, 1套2件",
        ],
        price: "499",
        orgPrice: "1130",
        discount: "45折",
        img: "/assets/images/2025/milk_lover_white.png",
        colorName: "白色",
        colorCode: "#FFFFFF",
        sku: "3594-SG-WH",
      },
    ],
  ],

  special: {
    title: "網上獨家 <span class='d-inline-block']>限量200套</span>",
    desc: "<b>+$1 換購</b>",
    detail: ` 
    <b>1. 30粒熱賣咖啡粉囊</b>
    <ul>
    <li>匠心之作 Roasted Hazelnut 咖啡 x10</li>
    <li>Espresso Altissio 咖啡 x10</li>
    <li>Long Black Odacio 咖啡 x10</li>
  </ul>
    <b>2. 隨行咖啡樽  x 1</b>`,
    price: "HKD 1",
    priceTotal: "HKD223",
  },

  cups: {
    title: "一觸即沖，<b>6種杯量</b>",
    desc: "輕觸按鈕即可隨心選擇6種咖啡杯量，釋放令人迷醉的優質香氣與油脂，為您締造非凡品味體驗",

    cups: [
      { name: "Ristretto", cap: "25毫升", img: "vl_ristretto.png" },
      { name: "Espresso", cap: "40毫升", img: "vl_espresso.png" },
      { name: "Double Espresso", cap: "80毫升", img: "vl_double-espresso.png" },
      { name: "Gran Lungo", cap: "150毫升", img: "vl_gran-lungo.png" },
      { name: "Mug", cap: "230毫升", img: "vl_mug.png" },
      { name: "Alto", cap: "355毫升", img: "vl_alto.png" },
    ],
  },

  includes: {
    title: "<b>咖啡套裝包括:</b>",
    desc: "可能會根據庫存情況而變化",

    details: [
      {
        tag: "Espresso | 40毫升",
        name: "Altissio 咖啡",
        desc: "口感豐潤而綿滑",
        bgColor: "#6C4A99",
        img: "capAltissio.png",
        best: true,
        content: {
          collpaseTitle: "咖啡食譜",
          img: "altissio_bg.jpg",
          title: "TIRAMISU 咖啡",
          icons: [
            { icon: "clock", txt: "8 分鐘" },
            { icon: "level", txt: "中等" },
          ],
          ingredient: [
            {
              name: "朱古力糖漿",
              cap: "2 茶匙",
              img: "altissio_choco.png",
            },
            {
              name: "奶酪",
              cap: "2 茶匙",
              img: "altissio_cheese.png",
            },
            {
              name: "牛奶",
              cap: "10 厘升",
              img: "altissio_milk.png",
            },
            {
              name: "焦糖餅乾",
              cap: "3 單位",
              img: "altissio_caramel.png",
            },
          ],
          steps: [
            "將朱古力糖漿加入配方杯中",
            "加入奶酪",
            "加入奶泡",
            "最後加入Nespresso Intenso",
            "撒上焦糖餅乾碎",
          ],
        },
      },

      {
        tag: "匠心之作 | 80 毫升",
        name: "蜜糖麥片",
        desc: "濃郁香醇，帶有堅果香氣",
        bgColor: "#873427",
        img: "capRoasted.png",
        best: true,
        content: {
          collpaseTitle: "咖啡食譜",
          img: "roastred_bg.jpg",
          title: "Roasted Hazlenut蜜糖麥片",
          icons: [
            { icon: "clock", txt: "3 分鐘" },
            { icon: "level", txt: "容易" },
          ],
          ingredient: [
            {
              name: "Roasted Hazelnut",
              cap: "230 毫升",
              img: "roasted_cap.png",
            },
            {
              name: "	純素麥片飲品",
              cap: "50 毫升",
              img: "roasted_beverage.png",
            },
            {
              name: "蜜糖",
              cap: "15 克",
              img: "roasted_honey.png",
            },
            {
              name: "	榛子碎",
              cap: "5 克",
              img: "roasted_nut.png",
            },
          ],
          steps: [
            "將榛子碎倒入淺身碟上，然後用蜜糖塗上咖啡杯緣，倒轉咖啡杯將榛子碎黏上杯緣，輕拍杯身跌出多餘的榛子。",
            "將蜜糖倒入 Vertuo 馥旋系列咖啡杯底，然後倒入冰凍的麥片飲品",
            "最後直接於咖啡杯沖調230 毫升「匠心之作」Roasted Hazlenut。",
            "請享用!",
          ],
        },
      },

      {
        tag: "Signature | 230毫升",
        name: "ODACIO 咖啡",
        desc: "滿溢果醬輕滲麥片甜味",
        bgColor: "#007194",
        img: "capOdacio.png",

        content: {
          collpaseTitle: "咖啡食譜",
          img: "odacio_bg.jpg",
          title: "冰咖啡",
          icons: [
            { icon: "clock", txt: "5 分鐘" },
            { icon: "level", txt: "中等" },
          ],
          ingredient: [
            { name: "冰粒", cap: "2 粒", img: "odacio_ice.png" },
            {
              name: "ODACIO 咖啡",
              cap: "1 粒",
              img: "odacio_cap.png",
            },
            {
              name: "12 oz. 玻璃杯",
              cap: "1 個",
              img: "odacio_glass.png",
            },
          ],
          steps: [
            "在玻璃杯中裝滿冰塊。",
            "沖調咖啡入金屬壺中。",
            "將咖啡倒在冰上以填滿玻璃杯。",
            "攪拌至冷卻即可飲用。",
          ],
        },
      },

      {
        tag: "咖啡樽容量 380毫升",
        name: "Touch Nomad 隨行咖啡樽",
        iconClass: "mug",
        bgColor: "#898989",
        img: "special-mug.png",
      },
    ],
  },

  machine: {
    title:
      "Vertuo Pop纖巧設計輕易融入任何廚房或工作空間。香濃旅程，由今日展開 !",
    video: "",
  },

  howToUse: {
    title: "如何<b>使用</b>",
    steps: [
      {
        txt: "放入咖啡粉囊",
        img: "howTo1.jpg",
      },
      {
        txt: "一鍵沖調咖啡",
        img: "howTo2.jpg",
      },
      {
        txt: "享受你的<br>咖啡時刻",
        img: "howTo3.jpg",
      },
    ],
  },

  feature: {
    title: "我們的<b>特色</b>",

    details: [
      {
        icon: "tech",
        txt: "CENTRIFUSION™ 科技",
      },
      {
        icon: "simple_touch",
        txt: "一鍵輕鬆沖調",
      },

      {
        icon: "automatic_brew_size",
        txt: "自動識別調節設定",
      },

      {
        icon: "connectivity",
        txt: "連線功能",
      },
    ],
  },

  suggestion: {
    title: "您可能<b>想知道</b>",
    details: [
      {
        img: "like1.png",
        txt: "哪一種咖啡系統最適合您？",
        link: "https://www.nespresso.com/hk/zh/choose-your-system",
      },
      {
        img: "like2.png",
        txt: "VERTUO 馥旋系列 咖啡粉囊",
        link: "https://www.nespresso.com/hk/zh/order/capsules/vertuo",
      },
      {
        img: "like3.png",
        txt: "選購咖啡配件",
        link: "https://www.nespresso.com/hk/zh/order/accessories#types[0]=%E5%92%96%E5%95%A1%E7%B2%89%E5%9B%8A%E7%9B%9B%E6%94%BE%E5%99%A8",
      },
      {
        img: "like4.png",
        txt: "選購咖啡粉囊",
        link: "https://www.nespresso.com/hk/zh/order/capsules/original",
      },
    ],
  },

  promote: {
    subtitle: "年終促銷",
    title: "咖啡機高達20%折扣",
    description: "Essenza Mini 及 Vertuo Pop 咖啡機除外",
    date: "2025年11月3日 – 2025年12月28日",
    cta: "探索優惠",
    ctaLink: "https://www.nespresso.com/hk/zh/order/machines/vertuo",
  },

  recipe: {
    title: "探索我們的咖啡食譜",
    description: "發現完美的咖啡食譜，提升您的咖啡體驗，享受每一杯的獨特風味。",
    viewAllButton: "查看所有食譜",
    step: "步驟",
    whatYouNeed: "所需材料",
    howToMake: "製作方法",
    popup: {
      servings: "份量",
      prepTime: "準備時間",
      ingredients: "材料",
      instructions: "製作步驟",
      tips: "小貼士",
      close: "關閉",
      minutes: "分鐘",
      people: "人",
    },
    tabs: {
      essenzaMini: "ESSENZA MINI",
      vertuoPop: "Vertuo Pop",
    },
    products: {
      essenzaMini: [
        {
          name: "薄荷 Coffee Mule",
          imagePath: "/assets/images/2025/recipe_ol_product_1.png",
          detail: {
            tag: "冰飲",
            title: "薄荷 Coffee Mule",
            desc: "呷一口薑檸冰咖啡，享受清新醒神時刻！青檸蓉、蜜糖、薑啤，加上咖啡和薄荷，舒爽滋味，為您喚醒感官！",
            time: "5 分鐘",
            difficulty: "容易",
            productImgPath: "/assets/images/2025/recipe_ol_product_1.png",
            howToMake: {
              steps: [
                "將新鮮天然青檸切半（30克），再分成6份，放進Nespresso Barista 調酒師咖啡杯中，並加入10毫升蜜糖。",
                "搗拌均勻，再加入3塊冰。",
                "加入60毫升薑啤，一邊輕輕攪拌一邊挑起青檸塊混合薑啤。",
                "提取40毫升咖啡至 Nespresso 調酒器中，加入2塊冰後蓋上蓋子用力搖勻。",
                "將咖啡輕輕倒在杯中的薑啤上，放上天然薄荷葉作裝飾。",
                "可選加：伏特加30毫升",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Essenza Mini",
                desc: "一按沖調Espresso和Lungo",
                price: "HKD999",
                sku: "161531",
                imgPath: "/assets/images/essenza-mini-piano-black.png",
              },
              cap: {
                name: "「佳節系列」 Double Espresso OL",
                desc: "含口感圓潤，入口散發麥片芬芳、成熟果香和焦糖氣息，並帶有清幽怡人的木材香氣。",
                sku: "7919.40",
                imgPath: "/assets/images/2025/recipe_ol_cap1.png",
                props: [
                  { name: "苦味", value: 3 },
                  { name: "酸度", value: 3 },
                  { name: "烘焙度", value: 3 },
                  { name: "醇厚度", value: 3 },
                ],
              },
              recipt: [
                "新鮮天然青檸 - 半個",
                "蜜糖 - 10毫升",
                "Nespresso 冰塊 - 6塊（30克）",
                "薑啤 - 60毫升",
                "Vertuo 馥旋系列 Double Espresso 咖啡 - 40毫升",
                "薄荷枝葉 - 1枝",
              ],
            },
          },
        },
        {
          name: "黃金洛神花 Latte",
          imagePath: "/assets/images/2025/recipe_ol_product_2.png",
          detail: {
            tag: "冰飲",
            title: "黃金洛神花 Latte",
            desc: "Sweet Almond and Hibiscus 配合熱奶、蜜糖和食用花，塑造花香四溢的滋味享受。如果加入意大利黑車厘子，更能增添意想不到的風味層次。",
            time: "5 分鐘",
            difficulty: "容易",
            productImgPath: "/assets/images/2025/recipe_ol_product_2.png",
            howToMake: {
              steps: [
                "用 Barista 飲品沖調器（熱奶模式）加熱100毫升1.5%低脂鮮奶。",
                "在 Festive 咖啡杯中，加入10毫升蜜糖。連按 Barista 飲品沖調器按鈕2下，啟動食譜模式，提取110毫升 Original 原創系列 Sweet Almond & Hibiscus 咖啡至杯中。",
                "將熱奶加至杯中。",
                "灑上食用玫瑰乾花或其他可食用花。",
                "可選加：在旁邊放上2顆意大利黑車厘子。",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Essenza Mini",
                desc: "一按沖調Espresso和Lungo",
                price: "HKD999",
                sku: "161531",
                imgPath: "/assets/images/essenza-mini-piano-black.png",
              },
              cap: {
                name: "「佳節系列」Sweet Almond and Hibiscus OL",
                desc: "甜潤的咖啡之中，透現杏仁、洛神花、紅色水果及焦糖香氣。",
                sku: "7907.40",
                imgPath: "/assets/images/2025/recipe_ol_cap2.png",
                props: [
                  { name: "苦味", value: 2 },
                  { name: "酸度", value: 3 },
                  { name: "烘焙度", value: 2 },
                  { name: "醇厚度", value: 2 },
                ],
              },
              recipt: [
                "蜜糖 - 10毫升",
                "Original 原創系列 Sweet Almond and Hibiscus 粉囊 - 1粒",
                "1.5%低脂鮮奶 - 100毫升",
                "糖漬意大利黑車厘子 - 2顆",
                "食用玫瑰乾花 - 1克",
              ],
            },
          },
        },
        {
          name: "肉桂雲朵 Latte",
          imagePath: "/assets/images/2025/recipe_ol_product_3.png",
          detail: {
            tag: "冰飲",
            title: "肉桂雲朵 Latte",
            desc: "為「佳節系列」Cinnamon and Candied Tamarind 咖啡添上濃厚忌廉，提升香濃層次，襯托窩心的肉桂風味。",
            time: "5 分鐘",
            difficulty: "容易",
            productImgPath: "/assets/images/2025/recipe_ol_product_3.png",
            howToMake: {
              steps: [
                "在忌廉打發器中加入500毫升忌廉及1粒忌廉氣彈*，再用力搖晃。",
                "用 Barista 飲品沖調器（熱奶模式）加熱100毫升鮮奶。",
                "在 Festive 咖啡杯中加入10毫升椰棗糖漿，提取110毫升 Original 原創系列 Cinnamon and Candied Tamarind 咖啡至杯中。",
                "將熱奶加至杯中，並在上面放上60克打好的忌廉。",
                "在忌廉中插上肉桂棒，再灑上肉桂粉。",
                "可選加：將茶包放進70毫升熱水中沖泡，放涼後再倒入忌廉打發器剩餘的忌廉中。",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Essenza Mini",
                desc: "一按沖調Espresso和Lungo",
                price: "HKD999",
                sku: "161531",
                imgPath: "/assets/images/essenza-mini-piano-black.png",
              },
              cap: {
                name: "「佳節系列」Cinnamon and Candied Tamarind OL",
                desc: "香甜的咖啡中，散發肉桂、香料、羅望子與果乾風味。",
                sku: "7903.40",
                imgPath: "/assets/images/2025/recipe_ol_cap3.png",
                props: [
                  { name: "苦味", value: 2 },
                  { name: "酸度", value: 3 },
                  { name: "烘焙度", value: 2 },
                  { name: "醇厚度", value: 2 },
                ],
              },
              recipt: [
                "椰棗糖漿 - 10毫升",
                "Vertuo 馥旋系列 Cinnamon and Candied Tamarind 粉囊 - 1粒",
                "1.5%低脂鮮奶 - 100毫升",
                "忌廉（35%乳脂）- 500毫升",
                "肉桂粉及肉桂棒 - 1份",
                "茶包 - 1個（可選加）",
              ],
            },
          },
        },
      ],
      vertuoPop: [
        {
          name: "薄荷 Coffee Mule",
          imagePath: "/assets/images/2025/recipe_vl_product_1.png",
          detail: {
            tag: "",
            title: "薄荷 Coffee Mule",
            desc: "呷一口薑檸冰咖啡，享受清新醒神時刻！青檸蓉、蜜糖、薑啤，加上咖啡和薄荷，舒爽滋味，為您喚醒感官！",
            time: "5分鐘",
            difficulty: "容易",
            productImgPath: "/assets/images/2025/recipe_vl_product_1.png",
            howToMake: {
              steps: [
                "在 Nespresso Mixology 玻璃杯中放入半個新鮮未經處理的青檸（30克），切成6塊，加入10毫升蜂蜜。",
                "搗碎。放入3塊冰塊。",
                "倒入60毫升薑汁啤酒。輕輕攪拌，同時提起青檸塊混合。",
                "在 Nespresso 搖杯中，提取40毫升咖啡並加入2塊冰塊，蓋上蓋子，用力搖晃。",
                "將冰咖啡輕輕倒入玻璃杯中的混合物上。在頂部加上一枝漂亮的未經處理的薄荷葉。",
                "可選：30毫升伏特加",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Vertuo Pop",
                desc: "最小的 Vertuo 咖啡機",
                price: "HKD999",
                sku: "161568",
                imgPath: "/assets/images/2025/vertuo_pop_blue.png",
              },
              cap: {
                name: "「佳節系列」Double Espresso",
                desc: "美味圓潤的杯子，帶有穀物、成熟水果和焦糖香調，並以微妙的木質底調完美襯托。",
                sku: "7079.40",
                imgPath: "/assets/images/2025/recipe_vl_cap1.png",
                props: [
                  { name: "苦味", value: 3 },
                  { name: "酸度", value: 3 },
                  { name: "烘焙度", value: 3 },
                  { name: "醇厚度", value: 3 },
                ],
              },
              recipt: [
                "新鮮未經處理青檸半個",
                "蜂蜜：10毫升",
                "Nespresso 冰塊6塊（30克）",
                "薑汁啤酒：60毫升",
              ],
            },
          },
        },
        {
          name: "黃金洛神花 Latte",
          imagePath: "/assets/images/2025/recipe_vl_product_2.png",
          detail: {
            tag: "",
            title: "黃金洛神花 Latte",
            desc: "享受我們的甜杏仁和洛神花飲品，結合溫牛奶、蜂蜜和芳香食用花朵，帶來花香舒適的享受，可選擇加入黑阿瑪雷納櫻桃增添額外風味！",
            time: "5分鐘",
            difficulty: "容易",
            productImgPath: "/assets/images/2025/recipe_vl_product_2.png",
            howToMake: {
              steps: [
                "用 Barista 飲品沖調器（熱奶模式）加熱100毫升1.5%牛奶。",
                "在節日馬克杯中，放入10毫升蜂蜜並提取110毫升 OL Sweet Almond & Hibiscus（雙擊食譜模式）。",
                "將熱牛奶倒入馬克杯中。",
                "撒上一些乾燥的食用玫瑰花或類似的芳香食用花朵。",
                "可選：加入2顆黑阿瑪雷納櫻桃（在旁邊）",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Vertuo Pop",
                desc: "最小的 Vertuo 咖啡機",
                price: "HKD999",
                sku: "161568",
                imgPath: "/assets/images/2025/vertuo_pop_blue.png",
              },
              cap: {
                name: "「佳節系列」調味杏仁和洛神花",
                desc: "節日美味，喚起杏仁、洛神花、紅色水果和焦糖在甜咖啡基底中的味道。",
                sku: "7078.40",
                imgPath: "/assets/images/2025/recipe_vl_cap2.png",
                props: [
                  { name: "苦味", value: 2 },
                  { name: "酸度", value: 2 },
                  { name: "烘焙度", value: 2 },
                  { name: "醇厚度", value: 2 },
                ],
              },
              recipt: [
                "蜂蜜：10毫升",
                "OL Sweet Almond & Hibiscus 1粒",
                "1.5%牛奶：100毫升",
                "阿瑪雷納櫻桃2顆（糖漿）",
                "食用玫瑰乾花：1克",
              ],
            },
          },
        },
        {
          name: "肉桂雲朵 Latte",
          imagePath: "/assets/images/2025/recipe_vl_product_2.png",
          detail: {
            tag: "",
            title: "肉桂雲朵拿鐵",
            desc: "品嚐節日肉桂和蜜餞羅望子咖啡，配有豐富的鮮奶油、芳香咖啡和一絲肉桂，帶來舒適的享受！",
            time: "5分鐘",
            difficulty: "容易",
            productImgPath: "/assets/images/2025/recipe_vl_product_2.png",
            howToMake: {
              steps: [
                "在0.5升的奶油打發器中，放入500毫升奶油和一個奶油充氣彈*。然後用力搖晃。",
                "用 Barista 飲品沖調器（熱奶模式）加熱100毫升牛奶。",
                "在節日馬克杯中，放入10毫升椰棗糖漿並提取110毫升 OL Cinnamon and Candied Tamarind 咖啡。",
                "將熱牛奶倒入馬克杯中，並在頂部加上60克打發奶油。",
                "在奶油中插入肉桂棒並撒上肉桂粉。",
                "可選：將茶包在70毫升熱水中浸泡，冷卻後加入打發器中的奶油。",
              ],
            },
            whatYouWant: {
              machine: {
                name: "Vertuo Pop",
                desc: "最小的 Vertuo 咖啡機",
                price: "HKD999",
                sku: "161568",
                imgPath: "/assets/images/2025/vertuo_pop_blue.png",
              },
              cap: {
                name: "「佳節系列」Cinnamon and Candied Tamarind VL",
                desc: "節日美味，喚起肉桂、香料、羅望子和乾果在甜咖啡基底中的味道。",
                sku: "7075.40",
                imgPath: "/assets/images/2025/recipe_vl_cap3.png",
                props: [
                  { name: "苦味", value: 2 },
                  { name: "酸度", value: 2 },
                  { name: "烘焙度", value: 2 },
                  { name: "醇厚度", value: 2 },
                ],
              },
              recipt: [
                "椰棗糖漿：10毫升",
                "OL Cinnamon & Tamarind 咖啡 1粒",
                "1.5%牛奶：100毫升",
                "35%奶油：500毫升",
                "肉桂粉和肉桂棒 1份",
                "茶包 1個",
              ],
            },
          },
        },
      ],
    },
  },

  crossSelling: {
    title: "更多推薦",
    subtitle: "提升您的咖啡體驗－購買更多，享受更多！",
    addToCart: "加入購物車",
    products1: [
      {
        name: "Vertuo 匠心之作精選 6 筒粉囊套裝",
        sku: "155577",
        price: 550,
        addon: "購買此商品即可享有節日優惠第 3 層",
        img: "/assets/images/2025/crosssell_vl_6_sleeve.png",
      },
      {
        name: "佳節系列 6 筒粉囊套裝",
        sku: "159540",
        price: 499,
        // addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 2",
        img: "/assets/images/2025/crosssell_vl_6_fest_sleeve.png",
      },

      {
        name: "佳節系列 9 筒粉囊套裝",
        sku: "159542",
        price: 871,
        // addon: "BUY THIS TO ENJOY FESTIVE OFFER TIER 2",
        img: "/assets/images/2025/crosssell_vl_9_fest_sleeve.png",
      },

      {
        name: "Double Espresso 咖啡",
        sku: "7079.40",
        price: 113,
        addon: "",
        img: "/assets/images/2025/vl_cap_1.png",
      },
      {
        name: "Almond Hibsicus 咖啡",
        sku: "7078.40",
        price: 113,
        addon: "",
        img: "/assets/images/2025/vl_cap_2.png",
      },
      {
        name: "Cinnamon Tamarind 咖啡",
        sku: "7075.40",
        price: 113,
        addon: "",
        img: "/assets/images/2025/vl_cap_3.png",
      },
    ],
    products2: [
      {
        name: "環球之旅10筒咖啡粉囊套裝",
        sku: "128142",
        price: 500,
        addon: "購買此商品即可享有節日優惠第 3 層",
        img: "/assets/images/2025/crosssell_org_10_sleeve.png",
      },
      {
        name: "佳節系列 5 筒粉囊套裝",
        sku: "159534",
        price: 308,
        // addon: "購買此商品即可享有節日優惠第 2 層",
        img: "/assets/images/2025/crosssell_org_5_sleeve.png",
      },
      {
        name: "佳節系列 10 筒粉囊套裝",
        sku: "159536",
        price: 615,
        // addon: "購買此商品即可享有節日優惠第 2 層",
        img: "/assets/images/2025/crosssell_org_10_fest_sleeve.png",
      },

      {
        name: "Double Espresso 咖啡",
        sku: "7919.40",
        price: 78,
        addon: "",
        img: "/assets/images/2025/ol_cap_1.png",
      },
      {
        name: "Almond Hibsicus 咖啡",
        sku: "7907.40",
        price: 78,
        addon: "",
        img: "/assets/images/2025/ol_cap_2.png",
      },
      {
        name: "Cinnamon Tamarind 咖啡",
        sku: "7903.40",
        price: 78,
        addon: "",
        img: "/assets/images/2025/ol_cap_3.png",
      },
    ],
  },

  machine: {
    title:
      "Vertuo Pop纖巧設計輕易融入任何廚房或工作空間。香濃旅程，由今日展開 !",
    video: "",
  },

  howToUse: {
    title: "如何<b>使用</b>",
    steps: [
      {
        txt: "放入咖啡粉囊",
        img: "howTo1.jpg",
      },
      {
        txt: "一鍵沖調咖啡",
        img: "howTo2.jpg",
      },
      {
        txt: "享受你的<br>咖啡時刻",
        img: "howTo3.jpg",
      },
    ],
  },

  feature: {
    title: "我們的<b>特色</b>",

    details: [
      {
        icon: "tech",
        txt: "CENTRIFUSION™ 科技",
      },
      {
        icon: "simple_touch",
        txt: "一鍵輕鬆沖調",
      },

      {
        icon: "automatic_brew_size",
        txt: "自動識別調節設定",
      },

      {
        icon: "connectivity",
        txt: "連線功能",
      },
    ],
  },

  suggestion: {
    title: "您可能<b>想知道</b>",
    details: [
      {
        img: "like1.png",
        txt: "哪一種咖啡系統最適合您？",
        link: "https://www.nespresso.com/hk/zh/choose-your-system",
      },
      {
        img: "like2.png",
        txt: "VERTUO 馥旋系列 咖啡粉囊",
        link: "https://www.nespresso.com/hk/zh/order/capsules/vertuo",
      },
      {
        img: "like3.png",
        txt: "選購咖啡配件",
        link: "https://www.nespresso.com/hk/zh/order/accessories#types[0]=%E5%92%96%E5%95%A1%E7%B2%89%E5%9B%8A%E7%9B%9B%E6%94%BE%E5%99%A8",
      },
      {
        img: "like4.png",
        txt: "選購咖啡粉囊",
        link: "https://www.nespresso.com/hk/zh/order/capsules/original",
      },
    ],
  },

  promote: {
    subtitle: "年終促銷",
    title: "咖啡機高達20%折扣",
    description: "Essenza Mini 及 Vertuo Pop 咖啡機除外",
    date: "2025年11月3日 – 2025年12月28日",
    cta: "探索優惠",
    ctaLink: "https://www.nespresso.com/hk/zh/order/machines/vertuo",
  },

  tab: {
    vertuo: {
      title: "VERTUO",
      subtitle: "全系列咖啡風格",
    },
    original: {
      title: "ORIGINAL",
      subtitle: "經典意式濃縮體驗",
    },
  },

  addonSection: {
    title: '附加優惠<br class="hide-desktop"/>為您帶來最優質體驗！',
    data: [
      {
        image: "/assets/images/addon-brown-sugar1.png",
        name: "黃糖",
        price: "HK $19",
        originalPrice: "HK $66",
        discount: "71% OFF",
        sku: "3517",
      },
      {
        image: "/assets/images/addon-recycling-bin.png",
        name: "回收箱",
        price: "HK $99",
        originalPrice: "HK $170",
        discount: "41% OFF",
        sku: "128557",
      },
      {
        image: "/assets/images/addon-collection.png",
        name: "VIEW Versilo 透明咖啡粉囊分配器 - Original",
        price: "HK $199",
        originalPrice: "HK $400",
        discount: "50% OFF",
        sku: "3586",
      },
      {
        image: "/assets/images/addon-coffee-capsule.png",
        name: "展示收藏垂直分配器 - Vertuo",
        price: "HK $199",
        originalPrice: "HK $400",
        discount: "50% OFF",
        sku: "133246",
      },
      {
        image: "/assets/images/addon-pen.png",
        name: " Nespresso x Caran D'Ache 原子筆",
        price: "HK $199",
        originalPrice: "HK $300",
        discount: "33% OFF",
        sku: "133492",
      },
    ],
  },

  purchaseProcess: {
    title: "購買流程",
    description: "按照這些簡單步驟完成您的購買",
  },

  tnc: {
    title: "Nespresso eCom Vertuo Pop 兌換推廣",
    desc: `<p>購買原價HKD 1,088的Vertuo Pop咖啡機，即可以$1兌換價兌換一套<b>精選3袖Vertuo咖啡粉囊</b>及一個<b>Touch Nomad隨行咖啡樽</b>。限量200套。</p>
    
    <h3>條款及細則適用</h3>

    <ol>
<li>購買原價HKD 1,088的Vertuo Pop咖啡機，即可以$1兌換價兌換一套<b>精選3袖Vertuo咖啡粉囊</b>（包括10粒匠心之作Roasted Hazelnut、10粒Espresso Altissio及10粒Long Black Odacio）及一個<b>Touch Nomad隨行咖啡樽</b>。</li>
<li>推廣期由2024年5月6日至2024年6月16日，售完即止，只限香港及澳門。只有200套可供兌換。</li>
<li>此推廣只適用於Nespresso網上精品店（www.nespresso.com/hk及手機應用程式）及客戶服務熱線（香港：8101 1007，澳門：0800 846）。</li>
<li>此推廣不適用於精品店取貨服務。</li>
<li>此推廣不可兌換現金、其他產品或更改，亦不可與Nespresso及Nespresso貿易夥伴的其他推廣優惠同時使用。</li>
<li>如有任何爭議，Nespresso（雀巢香港有限公司旗下品牌）保留最終決定及詮釋權。</li>
<li>每位會員每次訂單只可享用此優惠一次。</li>
</ol>
    `,
  },
};
